export default __webpack_public_path__ + "static/media/icon-error-triangle.1478800e.svg";